import styled from 'styled-components';
import type {
  CSSObject,
} from 'styled-components';

import {
  Td,
  getHoverStyle,
} from './Td';

import {
  TableComponent,
  TableProps,
} from './types';

export const Table: TableComponent = styled.table<TableProps>(({
  lightenRow,

  theme,
  theme: {
    colors,
  },
}) => {
  const res: CSSObject = {
    width: '100%',
    borderCollapse: 'collapse',
  };

  if (typeof lightenRow === 'number') {
    res[`& > tbody > tr:nth-child(${lightenRow + 1})`] = {
      backgroundColor: colors.ACTION_BACKGROUND,
    };

    res[`& > tbody > tr:nth-child(${lightenRow + 1}) ${Td}`] = getHoverStyle(theme);
  }

  return res;
});
